import React, {Component} from 'react';
import './Home.css';
import Category from "./CategoryButtons/Category";
import Search from "./Search/Search";
import getServices from "../GerServices/GetServices";

/*  Объяснения */
/*
    this.state.randoms.indexOf(this.state.value) === -1   Означает что если this.state.value != ни одному элемунту из массива this.state.randoms
    this.state.randoms.indexOf(this.state.value) > 1   Означает что this.state.value = одному элемунту из массива this.state.randoms

    makeRequestRandom  При запросе Random(math/trivia и так далее) значения, будет смотреть разрешение true или false

    randoms[0] в randoms: ['', 'random/math', 'random/trivia', 'random/date', 'random/year'] Для того что бы при нажатии на Clear невыполнялось 1е условие(запрос на новое значение)
 */

export default class Home extends Component {
    getServices = new getServices();

    state = {
        /* dataBase about Number */
        aNumber: null,

        /*Value form search panel*/
        value: '',
        makeRequest: false,

        randoms: ['', 'random/math', 'random/trivia', 'random/date', 'random/year']
    }

    UpdateValue = (data, trueOrFalse = false) => {
        this.setState({
            makeRequest: trueOrFalse,
            value: data,
        })
    }

    componentDidMount() {
        this.getServices.getData('0/trivia', 'fragment=true&notfound=floor&json=true' )
            .then(data => {
                this.setState({
                    aNumber: data
                })
            })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        /* For get number from search panel */
        if( prevState.value !== this.state.value && this.state.randoms.indexOf(this.state.value) === -1 && this.state.value !== 'Undefined') {
            return this.getServices.getData(this.state.value, 'fragment=true&json=true')
                    .then( data => {
                        this.setState( {
                            aNumber: data,
                        } )
                    } )
                    .catch(error => {
                        console.log(error);
                        this.setState({
                            value: 'Undefined',
                            error: false,
                            aNumber:
                                {found: 'Undefined',
                                ReNumber: 'Undefined'.split(''),
                                number: null,
                                type: 'Undefined',
                                text: 'Please, enter correct value or try again'}
                        })
                    });

        } else if( ( this.state.randoms.indexOf(this.state.value) > -1 ) && this.state.makeRequest === true ) {
            return this.getServices.getData(this.state.value, 'max=9999&fragment=true&min=0&json=true')
                .then( data => {
                    this.setState( {
                        aNumber: data,
                        makeRequest: false
                    } )
                } )
                .catch(error => {
                    console.log(error);
                    this.setState({
                        value: 'Undefined',
                        error: false,
                        aNumber:
                            {found: 'Undefined',
                                ReNumber: 'Undefined'.split(''),
                                number: null,
                                type: 'Undefined',
                                text: 'Please, enter correct value or try again'}
                    })
                });
        } else if ( prevState.value !== this.state.value && this.state.value === '' ) {
            return this.setState({
                value: ''
            })
        } else if ( this.state.value === 'Undefined' && this.state.error === false ) {
            return this.setState({
                value: 'Undefined',
                error: true,
                aNumber:
                    {found: 'Undefined',
                        ReNumber: 'Undefined'.split(''),
                        number: null,
                        type: 'Undefined',
                        text: 'Please, enter correct value or try again'}
            })
        } else if ( this.state.value === '' && this.state.error === false ) {
            return this.setState({
                value: 'Undefined',
                error: true,
                aNumber:
                    {found: 'Undefined',
                        ReNumber: 'Undefined'.split(''),
                        number: null,
                        type: 'Undefined',
                        text: 'Please, enter correct value or try again'}
            })
        }
    }


    render() {
        return (
            <div className="Home">
                <div className={"container"}>
                    <Category UpdateValue={this.UpdateValue}/>
                    <Search
                        state={this.state}
                        UpdateValue={this.UpdateValue}/>
                </div>
            </div>
        );
    }
}
